function toIdString(value) {
  if (value === null || value === undefined) return '';
  return String(value).trim();
}

function isUsableReviewId(value) {
  const id = toIdString(value);
  return !!id && /^\d+$/.test(id);
}

function normalizeMyReviewItem(item) {
  const source = item || {};
  const reviewIdCandidate = source.reviewId || source.id || source.rateId;

  return {
    reviewId: isUsableReviewId(reviewIdCandidate) ? toIdString(reviewIdCandidate) : '',
    houseId: toIdString(source.houseId),
    houseLetId: toIdString(source.houseLetId),
    average: source.average,
  };
}

function buildMyReviewNavigation(item) {
  const normalized = normalizeMyReviewItem(item);

  if (normalized.reviewId) {
    return {
      path: '/showReview',
      query: {
        id: normalized.reviewId,
        expectedAverage: normalized.average !== undefined && normalized.average !== null
          ? String(normalized.average)
          : undefined,
      },
    };
  }

  return {
    path: '/HouseReviewScore',
    query: {
      houseId: normalized.houseId,
      houseLetId: normalized.houseLetId,
    },
  };
}

module.exports = {
  buildMyReviewNavigation,
  normalizeMyReviewItem,
};
